<template>
  <div class="top-menu--content">
    <div class="top-menu--content-header">
      <ul>
        <li><span><a class="notA" href="tel:+33428296594">{{ $t('topbar.info.phone') }}</a></span></li>
        <li>
          <a href="https://www.facebook.com/mihotel.fr/">
            <svg id="Bold" enable-background="new 0 0 24 24" height="512" viewBox="0 0 24 24" width="512"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill="#FFF"
                    d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323
                      5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077
                      2.051-2.077z"/>
            </svg>
          </a>
        </li>
        <li>
          <a href="https://twitter.com/mihotelfrance">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px" y="0px"
                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path fill="#FFF" d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
                c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
                c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
                c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
                c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
                c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
                C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
                C480.224,136.96,497.728,118.496,512,97.248z"/>
            </svg>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/mi.hotel/">
            <svg id="Bold" enable-background="new 0 0 24 24" height="512" viewBox="0 0 24 24" width="512"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill="#FFF"
                    d="m12.004 5.838c-3.403 0-6.158 2.758-6.158 6.158 0 3.403 2.758 6.158 6.158 6.158 3.403 0 6.158-2.758
                    6.158-6.158 0-3.403-2.758-6.158-6.158-6.158zm0 10.155c-2.209 0-3.997-1.789-3.997-3.997s1.789-3.997
                    3.997-3.997 3.997 1.789 3.997 3.997c.001 2.208-1.788 3.997-3.997 3.997z"/>
              <path fill="#FFF"
                    d="m16.948.076c-2.208-.103-7.677-.098-9.887 0-1.942.091-3.655.56-5.036 1.941-2.308 2.308-2.013
                    5.418-2.013 9.979 0 4.668-.26 7.706 2.013 9.979 2.317 2.316 5.472 2.013 9.979 2.013 4.624 0
                    6.22.003 7.855-.63 2.223-.863 3.901-2.85 4.065-6.419.104-2.209.098-7.677 0-9.887-.198-4.213-2.459-6.768-6.976-6.976zm3.495
                    20.372c-1.513 1.513-3.612 1.378-8.468 1.378-5 0-7.005.074-8.468-1.393-1.685-1.677-1.38-4.37-1.38-8.453 0-5.525-.567-9.504
                    4.978-9.788 1.274-.045 1.649-.06 4.856-.06l.045.03c5.329 0 9.51-.558 9.761 4.986.057 1.265.07 1.645.07 4.847-.001 4.942.093 6.959-1.394 8.453z"/>
              <circle fill="#FFF" cx="18.406" cy="5.595" r="1.439"/>
            </svg>
          </a>
        </li>
        <li>
          <a href="https://www.tiktok.com/@mihotel_"  class="tiktok" target="_blank">
            <svg fill="#FFF" width="800px" height="800px" viewBox="0 0 512 512" id="icons" xmlns="http://www.w3.org/2000/svg"><path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
          </a>
        </li>
      </ul>
    </div>
    <div class="top-menu--content-navigation">
      <ul>
        <li :class="{active: page === 1}" @click="page = 1">{{ $t('mobileMenu.navigation') }}</li>
        <li v-if="cartCount === 0" :class="{active: page === 2}" @click="page = 2">{{ $t('mobileMenu.cart') }}</li>
        <li v-else :class="{active: page === 2}" @click="page = 2">{{ $t('mobileMenu.cart') }}
          ({{ cartCount > 9 ? '9+' : cartCount }})
        </li>
      </ul>
    </div>
    <div class="top-menu--content-page with-scrollbar" v-if="page === 1">
      <mobile-navigation/>
    </div>
    <div class="top-menu--content-page with-scrollbar" v-if="page === 2">
      <mobile-cart/>
    </div>
  </div>
</template>

<script>
import MobileCart from "./mobile-cart";
import MobileNavigation from "./mobile-navigation";

export default {
  name: "mobile-menu-navigation",
  components: {MobileNavigation, MobileCart},
  computed: {
    cartCount() {
      return this.$store.getters["shoppingCart/cartCount"]
    }
  },
  data() {
    return {
      page: 1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/mobile-menu-navigation.vue